import { Link } from "react-router-dom";
import "../App.css";

function Home() {
  return (
    <div id="container">
      <div class="">
        <div class="">
          <div class="tailwind css-myl2ny css-exq74d css-gs60ek">
            <div class="min-h-screen transition-colors duration-200 bg-gray-50 text-gray-900">
              <div class="border-b sticky top-0 z-40 backdrop-blur-sm bg-white/95 border-gray-200">
                <div class="max-w-7xl mx-auto px-6 py-4">
                  <div class="flex items-center justify-between">
                    <div class="flex items-center gap-4">
                      <div class="flex items-center gap-3">
                        <img
                          src="/sai-logo.avif"
                          alt="SAI Agent"
                          class="w-8 h-8"
                        />
                        <div>
                          <h1 class="font-semibold text-lg text-gray-900">
                            SAI Agent
                          </h1>
                          <p class="text-xs text-gray-500">Company Summary</p>
                        </div>
                      </div>
                      <div
                        data-orientation="vertical"
                        role="none"
                        data-slot="separator-root"
                        class="bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px h-8"
                      ></div>
                      <div class="flex items-center gap-3">
                        <div class="flex items-center gap-2 text-gray-700">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-building2 lucide-building-2 w-5 h-5"
                            aria-hidden="true"
                          >
                            <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
                            <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
                            <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>
                            <path d="M10 6h4"></path>
                            <path d="M10 10h4"></path>
                            <path d="M10 14h4"></path>
                            <path d="M10 18h4"></path>
                          </svg>
                          <span class="font-medium">Kaseya</span>
                        </div>
                        <span
                          data-slot="badge"
                          class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden text-foreground [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-briefcase w-3 h-3 mr-1"
                            aria-hidden="true"
                          >
                            <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                            <rect
                              width="20"
                              height="14"
                              x="2"
                              y="6"
                              rx="2"
                            ></rect>
                          </svg>
                          IT Management &amp; Cybersecurity
                        </span>
                        <span
                          data-slot="badge"
                          class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden border-transparent [a&amp;]:hover:bg-primary/90 text-xs bg-sai-blue text-white"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-award w-3 h-3 mr-1"
                            aria-hidden="true"
                          >
                            <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                            <circle cx="12" cy="8" r="6"></circle>
                          </svg>
                          Insight Partners Portfolio
                        </span>
                      </div>
                    </div>
                    <div class="flex items-center gap-3">
                      <button
                        data-slot="button"
                        class="justify-center whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive h-9 has-[&gt;svg]:px-3 flex items-center gap-2 bg-sai-blue hover:bg-sai-blue-hover text-white px-6 py-2 shadow-md"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-play w-4 h-4"
                          aria-hidden="true"
                        >
                          <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"></path>
                        </svg>
                        <Link to="/summary">Run Full Analysis</Link>
                      </button>
                      <button
                        data-slot="button"
                        class="justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border bg-background text-foreground hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 h-8 rounded-md px-3 has-[&gt;svg]:px-2.5 flex items-center gap-2"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-file-text w-4 h-4"
                          aria-hidden="true"
                        >
                          <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                          <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                          <path d="M10 9H8"></path>
                          <path d="M16 13H8"></path>
                          <path d="M16 17H8"></path>
                        </svg>
                        Export Report
                      </button>
                      <button
                        data-slot="button"
                        class="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50 h-8 rounded-md gap-1.5 px-3 has-[&gt;svg]:px-2.5"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-moon w-4 h-4"
                          aria-hidden="true"
                        >
                          <path d="M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401"></path>
                        </svg>
                      </button>
                      <div class="flex items-center gap-2">
                        <div class="avatar-circle" data-initials="GC"></div>
                        <span class="text-sm font-medium text-gray-900">
                          Gordon Caplan
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="max-w-7xl mx-auto px-6 py-8">
                <div class="mb-8">
                  <div class="flex items-start justify-between mb-4">
                    <div>
                      <h1 class="text-3xl font-semibold mb-2 text-gray-900">
                        Kaseya
                      </h1>
                      <p class="text-lg mb-4 text-gray-600">
                        Complete IT Infrastructure &amp; Security Management
                      </p>
                      <div class="flex flex-wrap items-center gap-4 text-sm">
                        <div class="flex items-center gap-1 text-gray-500">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-calendar w-4 h-4"
                            aria-hidden="true"
                          >
                            <path d="M8 2v4"></path>
                            <path d="M16 2v4"></path>
                            <rect
                              width="18"
                              height="18"
                              x="3"
                              y="4"
                              rx="2"
                            ></rect>
                            <path d="M3 10h18"></path>
                          </svg>
                          Founded 2000
                        </div>
                        <div class="flex items-center gap-1 text-gray-500">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-map-pin w-4 h-4"
                            aria-hidden="true"
                          >
                            <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                          </svg>
                          Dublin, Ireland &amp; Miami, FL
                        </div>
                        <div class="flex items-center gap-1 text-gray-500">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-globe w-4 h-4"
                            aria-hidden="true"
                          >
                            <circle cx="12" cy="12" r="10"></circle>
                            <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
                            <path d="M2 12h20"></path>
                          </svg>
                          kaseya.com
                        </div>
                      </div>
                    </div>
                    <div class="flex flex-col items-end gap-2">
                      <span
                        data-slot="badge"
                        class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden border-transparent [a&amp;]:hover:bg-primary/90 bg-sai-green text-white"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-circle-check w-3 h-3 mr-1"
                          aria-hidden="true"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <path d="m9 12 2 2 4-4"></path>
                        </svg>
                        Active Investment
                      </span>
                      <div class="text-sm text-gray-500">
                        Last updated: Today
                      </div>
                    </div>
                  </div>
                  <p class="text-base leading-relaxed text-gray-600">
                    Kaseya is a leading provider of complete IT infrastructure
                    and security management solutions for Managed Service
                    Providers (MSPs) and mid-market enterprises. The company
                    delivers comprehensive remote monitoring, endpoint security,
                    and business management solutions.
                  </p>
                </div>
                <div
                  data-slot="card"
                  class="text-card-foreground flex flex-col gap-6 rounded-xl border p-6 mb-8 bg-white border-gray-200"
                >
                  <div class="flex items-center justify-between mb-6">
                    <div>
                      <h2 class="text-xl font-medium mb-2 text-gray-900">
                        Due Diligence Progress
                      </h2>
                      <div class="flex items-center gap-4">
                        <div class="text-sm text-gray-600">
                          Phase 3 of 6 • 42% Complete
                        </div>
                        <span
                          data-slot="badge"
                          class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden border-transparent [a&amp;]:hover:bg-primary/90 bg-sai-blue text-white"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-clock w-3 h-3 mr-1"
                            aria-hidden="true"
                          >
                            <path d="M12 6v6l4 2"></path>
                            <circle cx="12" cy="12" r="10"></circle>
                          </svg>
                          Current: Legal &amp; Financial DD
                        </span>
                      </div>
                    </div>
                    <div class="flex items-center gap-4">
                      <div class="flex items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-calendar-days w-4 h-4 text-gray-500"
                          aria-hidden="true"
                        >
                          <path d="M8 2v4"></path>
                          <path d="M16 2v4"></path>
                          <rect
                            width="18"
                            height="18"
                            x="3"
                            y="4"
                            rx="2"
                          ></rect>
                          <path d="M3 10h18"></path>
                          <path d="M8 14h.01"></path>
                          <path d="M12 14h.01"></path>
                          <path d="M16 14h.01"></path>
                          <path d="M8 18h.01"></path>
                          <path d="M12 18h.01"></path>
                          <path d="M16 18h.01"></path>
                        </svg>
                        <span class="text-sm text-gray-500">
                          Started Jan 15, 2024
                        </span>
                      </div>
                      <button
                        data-slot="button"
                        class="justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive h-8 rounded-md has-[&gt;svg]:px-2.5 flex items-center gap-2 bg-sai-blue hover:bg-sai-blue-hover text-white px-4 py-2 shadow-md"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-chart-column w-4 h-4"
                          aria-hidden="true"
                        >
                          <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                          <path d="M18 17V9"></path>
                          <path d="M13 17V5"></path>
                          <path d="M8 17v-3"></path>
                        </svg>
                        <Link to="/summary">Complete Analysis</Link>
                      </button>
                    </div>
                  </div>
                  <div class="relative">
                    <div
                      class="absolute top-7 h-1 bg-sai-blue opacity-30"
                      style={{ left: "3.5rem", right: "3.5rem" }}
                    ></div>
                    <div
                      class="absolute top-7 h-1 bg-sai-blue transition-all duration-500"
                      style={{ left: "3.5rem", width: "calc(41.6667% - 7rem)" }}
                    ></div>
                    <div class="relative grid grid-cols-6 gap-4">
                      <div class="relative flex flex-col items-center">
                        <div class="relative z-10 w-14 h-14 rounded-full flex items-center justify-center transition-all duration-200 bg-sai-blue shadow-md ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-search w-5 h-5 text-white"
                            aria-hidden="true"
                          >
                            <path d="m21 21-4.34-4.34"></path>
                            <circle cx="11" cy="11" r="8"></circle>
                          </svg>
                        </div>
                        <div class="mt-4 text-center">
                          <div class="text-sm font-medium mb-1 text-sai-blue">
                            Initial Screening
                          </div>
                          <div class="text-xs text-gray-500">2 weeks</div>
                          <div class="text-xs mt-1 text-gray-400">
                            Jan 15 - Jan 29
                          </div>
                        </div>
                      </div>
                      <div class="relative flex flex-col items-center">
                        <div class="relative z-10 w-14 h-14 rounded-full flex items-center justify-center transition-all duration-200 bg-sai-blue shadow-md ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-eye w-5 h-5 text-white"
                            aria-hidden="true"
                          >
                            <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                          </svg>
                        </div>
                        <div class="mt-4 text-center">
                          <div class="text-sm font-medium mb-1 text-sai-blue">
                            Deep Dive Analysis
                          </div>
                          <div class="text-xs text-gray-500">4 weeks</div>
                          <div class="text-xs mt-1 text-gray-400">
                            Jan 30 - Feb 26
                          </div>
                        </div>
                      </div>
                      <div class="relative flex flex-col items-center">
                        <div class="relative z-10 w-14 h-14 rounded-full flex items-center justify-center transition-all duration-200 bg-sai-blue shadow-md ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-scale w-5 h-5 text-white"
                            aria-hidden="true"
                          >
                            <path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"></path>
                            <path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"></path>
                            <path d="M7 21h10"></path>
                            <path d="M12 3v18"></path>
                            <path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"></path>
                          </svg>
                        </div>
                        <div class="mt-4 text-center">
                          <div class="text-sm font-medium mb-1 text-sai-blue">
                            Legal &amp; Financial DD
                          </div>
                          <div class="text-xs text-gray-500">4 weeks</div>
                          <div class="text-xs mt-1 text-gray-400">
                            Feb 27 - Mar 26
                          </div>
                        </div>
                      </div>
                      <div class="relative flex flex-col items-center">
                        <div class="relative z-10 w-14 h-14 rounded-full flex items-center justify-center transition-all duration-200 bg-white border-2 border-gray-200 shadow-sm ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-dollar-sign w-5 h-5 text-gray-400"
                            aria-hidden="true"
                          >
                            <line x1="12" x2="12" y1="2" y2="22"></line>
                            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                          </svg>
                        </div>
                        <div class="mt-4 text-center">
                          <div class="text-sm font-medium mb-1 text-gray-500">
                            Commercial Terms
                          </div>
                          <div class="text-xs text-gray-500">3 weeks</div>
                          <div class="text-xs mt-1 text-gray-400">
                            Mar 27 - Apr 16
                          </div>
                        </div>
                      </div>
                      <div class="relative flex flex-col items-center">
                        <div class="relative z-10 w-14 h-14 rounded-full flex items-center justify-center transition-all duration-200 bg-white border-2 border-gray-200 shadow-sm ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-vote w-5 h-5 text-gray-400"
                            aria-hidden="true"
                          >
                            <path d="m9 12 2 2 4-4"></path>
                            <path d="M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z"></path>
                            <path d="M22 19H2"></path>
                          </svg>
                        </div>
                        <div class="mt-4 text-center">
                          <div class="text-sm font-medium mb-1 text-gray-500">
                            Investment Committee
                          </div>
                          <div class="text-xs text-gray-500">2 weeks</div>
                          <div class="text-xs mt-1 text-gray-400">
                            Apr 17 - Apr 30
                          </div>
                        </div>
                      </div>
                      <div class="relative flex flex-col items-center">
                        <div class="relative z-10 w-14 h-14 rounded-full flex items-center justify-center transition-all duration-200 bg-white border-2 border-gray-200 shadow-sm ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-handshake w-5 h-5 text-gray-400"
                            aria-hidden="true"
                          >
                            <path d="m11 17 2 2a1 1 0 1 0 3-3"></path>
                            <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"></path>
                            <path d="m21 3 1 11h-2"></path>
                            <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"></path>
                            <path d="M3 4h8"></path>
                          </svg>
                        </div>
                        <div class="mt-4 text-center">
                          <div class="text-sm font-medium mb-1 text-gray-500">
                            Deal Execution
                          </div>
                          <div class="text-xs text-gray-500">2 weeks</div>
                          <div class="text-xs mt-1 text-gray-400">
                            May 1 - May 15
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-8">
                  <h2 class="text-xl font-medium mb-6 text-gray-900">
                    Key Performance Metrics
                  </h2>
                  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    <div
                      data-slot="card"
                      class="text-card-foreground flex flex-col gap-6 rounded-xl border p-6 bg-white border-gray-200"
                    >
                      <div class="flex items-start justify-between">
                        <div class="flex-1">
                          <div class="flex items-center gap-2 mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-dollar-sign w-5 h-5 text-gray-500"
                              aria-hidden="true"
                            >
                              <line x1="12" x2="12" y1="2" y2="22"></line>
                              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                            </svg>
                            <span class="text-sm font-medium text-gray-600">
                              Annual Recurring Revenue
                            </span>
                          </div>
                          <div class="text-2xl font-semibold mb-1 text-gray-900">
                            $218.6M
                          </div>
                          <div class="flex items-center gap-1 text-sm text-sai-green">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-trending-up w-4 h-4"
                              aria-hidden="true"
                            >
                              <path d="M16 7h6v6"></path>
                              <path d="m22 7-8.5 8.5-5-5L2 17"></path>
                            </svg>
                            +28% YoY
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      data-slot="card"
                      class="text-card-foreground flex flex-col gap-6 rounded-xl border p-6 bg-white border-gray-200"
                    >
                      <div class="flex items-start justify-between">
                        <div class="flex-1">
                          <div class="flex items-center gap-2 mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-users w-5 h-5 text-gray-500"
                              aria-hidden="true"
                            >
                              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                              <path d="M16 3.128a4 4 0 0 1 0 7.744"></path>
                              <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                              <circle cx="9" cy="7" r="4"></circle>
                            </svg>
                            <span class="text-sm font-medium text-gray-600">
                              Global Employees
                            </span>
                          </div>
                          <div class="text-2xl font-semibold mb-1 text-gray-900">
                            4,800+
                          </div>
                          <div class="flex items-center gap-1 text-sm text-sai-green">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-trending-up w-4 h-4"
                              aria-hidden="true"
                            >
                              <path d="M16 7h6v6"></path>
                              <path d="m22 7-8.5 8.5-5-5L2 17"></path>
                            </svg>
                            +15% YoY
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      data-slot="card"
                      class="text-card-foreground flex flex-col gap-6 rounded-xl border p-6 bg-white border-gray-200"
                    >
                      <div class="flex items-start justify-between">
                        <div class="flex-1">
                          <div class="flex items-center gap-2 mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-building2 lucide-building-2 w-5 h-5 text-gray-500"
                              aria-hidden="true"
                            >
                              <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
                              <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
                              <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>
                              <path d="M10 6h4"></path>
                              <path d="M10 10h4"></path>
                              <path d="M10 14h4"></path>
                              <path d="M10 18h4"></path>
                            </svg>
                            <span class="text-sm font-medium text-gray-600">
                              Customer Base
                            </span>
                          </div>
                          <div class="text-2xl font-semibold mb-1 text-gray-900">
                            50,000+
                          </div>
                          <div class="flex items-center gap-1 text-sm text-sai-green">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-trending-up w-4 h-4"
                              aria-hidden="true"
                            >
                              <path d="M16 7h6v6"></path>
                              <path d="m22 7-8.5 8.5-5-5L2 17"></path>
                            </svg>
                            +22% YoY
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      data-slot="card"
                      class="text-card-foreground flex flex-col gap-6 rounded-xl border p-6 bg-white border-gray-200"
                    >
                      <div class="flex items-start justify-between">
                        <div class="flex-1">
                          <div class="flex items-center gap-2 mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-server w-5 h-5 text-gray-500"
                              aria-hidden="true"
                            >
                              <rect
                                width="20"
                                height="8"
                                x="2"
                                y="2"
                                rx="2"
                                ry="2"
                              ></rect>
                              <rect
                                width="20"
                                height="8"
                                x="2"
                                y="14"
                                rx="2"
                                ry="2"
                              ></rect>
                              <line x1="6" x2="6.01" y1="6" y2="6"></line>
                              <line x1="6" x2="6.01" y1="18" y2="18"></line>
                            </svg>
                            <span class="text-sm font-medium text-gray-600">
                              Product Portfolio
                            </span>
                          </div>
                          <div class="text-2xl font-semibold mb-1 text-gray-900">
                            40+
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      data-slot="card"
                      class="text-card-foreground flex flex-col gap-6 rounded-xl border p-6 bg-white border-gray-200"
                    >
                      <div class="flex items-start justify-between">
                        <div class="flex-1">
                          <div class="flex items-center gap-2 mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-trending-up w-5 h-5 text-gray-500"
                              aria-hidden="true"
                            >
                              <path d="M16 7h6v6"></path>
                              <path d="m22 7-8.5 8.5-5-5L2 17"></path>
                            </svg>
                            <span class="text-sm font-medium text-gray-600">
                              Market Valuation
                            </span>
                          </div>
                          <div class="text-2xl font-semibold mb-1 text-gray-900">
                            $1.3B
                          </div>
                          <div class="flex items-center gap-1 text-sm text-sai-gray">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-clock w-4 h-4"
                              aria-hidden="true"
                            >
                              <path d="M12 6v6l4 2"></path>
                              <circle cx="12" cy="12" r="10"></circle>
                            </svg>
                            2024 Valuation
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      data-slot="card"
                      class="text-card-foreground flex flex-col gap-6 rounded-xl border p-6 bg-white border-gray-200"
                    >
                      <div class="flex items-start justify-between">
                        <div class="flex-1">
                          <div class="flex items-center gap-2 mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-globe w-5 h-5 text-gray-500"
                              aria-hidden="true"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
                              <path d="M2 12h20"></path>
                            </svg>
                            <span class="text-sm font-medium text-gray-600">
                              Global Presence
                            </span>
                          </div>
                          <div class="text-2xl font-semibold mb-1 text-gray-900">
                            20+ Countries
                          </div>
                          <div class="flex items-center gap-1 text-sm text-sai-green">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-trending-up w-4 h-4"
                              aria-hidden="true"
                            >
                              <path d="M16 7h6v6"></path>
                              <path d="m22 7-8.5 8.5-5-5L2 17"></path>
                            </svg>
                            Expanding EMEA
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-8">
                  <div
                    data-slot="card"
                    class="text-card-foreground flex flex-col gap-6 rounded-xl border p-6 border-l-4 bg-white border-gray-200"
                  >
                    <div class="flex items-center gap-3 mb-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-target w-6 h-6 text-sai-blue"
                        aria-hidden="true"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <circle cx="12" cy="12" r="6"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                      </svg>
                      <span class="text-xl font-medium text-gray-900">
                        Overall Risk Score
                      </span>
                    </div>
                    <div class="grid grid-cols-1 lg:grid-cols-4 gap-6 items-center">
                      <div class="lg:col-span-1">
                        <div class="text-4xl font-semibold text-sai-blue mb-1">
                          B+
                        </div>
                        <div class="text-base font-medium mb-1 text-gray-700">
                          Moderate risk profile
                        </div>
                        <div class="text-sm text-gray-500">
                          42 risk factors analyzed
                        </div>
                      </div>
                      <div class="lg:col-span-3">
                        <div class="grid grid-cols-2 md:grid-cols-3 gap-3">
                          <div class="p-3 rounded-lg border bg-gray-50 border-gray-200">
                            <div class="flex items-center justify-between mb-1">
                              <span class="text-sm font-medium text-gray-900">
                                Cybersecurity
                              </span>
                              <span
                                data-slot="badge"
                                class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-orange-600 dark:text-orange-400"
                              >
                                HIGH
                              </span>
                            </div>
                            <div class="text-xs text-gray-500">8 items</div>
                          </div>
                          <div class="p-3 rounded-lg border bg-gray-50 border-gray-200">
                            <div class="flex items-center justify-between mb-1">
                              <span class="text-sm font-medium text-gray-900">
                                Market Competition
                              </span>
                              <span
                                data-slot="badge"
                                class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-yellow-600 dark:text-yellow-400"
                              >
                                MEDIUM
                              </span>
                            </div>
                            <div class="text-xs text-gray-500">12 items</div>
                          </div>
                          <div class="p-3 rounded-lg border bg-gray-50 border-gray-200">
                            <div class="flex items-center justify-between mb-1">
                              <span class="text-sm font-medium text-gray-900">
                                Integration Risks
                              </span>
                              <span
                                data-slot="badge"
                                class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-yellow-600 dark:text-yellow-400"
                              >
                                MEDIUM
                              </span>
                            </div>
                            <div class="text-xs text-gray-500">6 items</div>
                          </div>
                          <div class="p-3 rounded-lg border bg-gray-50 border-gray-200">
                            <div class="flex items-center justify-between mb-1">
                              <span class="text-sm font-medium text-gray-900">
                                Regulatory Compliance
                              </span>
                              <span
                                data-slot="badge"
                                class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-yellow-600 dark:text-yellow-400"
                              >
                                MEDIUM
                              </span>
                            </div>
                            <div class="text-xs text-gray-500">9 items</div>
                          </div>
                          <div class="p-3 rounded-lg border bg-gray-50 border-gray-200">
                            <div class="flex items-center justify-between mb-1">
                              <span class="text-sm font-medium text-gray-900">
                                Customer Concentration
                              </span>
                              <span
                                data-slot="badge"
                                class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-green-600 dark:text-green-400"
                              >
                                LOW
                              </span>
                            </div>
                            <div class="text-xs text-gray-500">4 items</div>
                          </div>
                          <div class="p-3 rounded-lg border bg-gray-50 border-gray-200">
                            <div class="flex items-center justify-between mb-1">
                              <span class="text-sm font-medium text-gray-900">
                                Financial
                              </span>
                              <span
                                data-slot="badge"
                                class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-green-600 dark:text-green-400"
                              >
                                LOW
                              </span>
                            </div>
                            <div class="text-xs text-gray-500">3 items</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
                  <div class="lg:col-span-2">
                    <h2 class="text-xl font-medium mb-6 text-gray-900">
                      Risk Assessment Overview
                    </h2>
                    <div class="space-y-4">
                      <div data-state="closed" data-slot="collapsible">
                        <div
                          data-slot="card"
                          class="text-card-foreground flex flex-col gap-6 rounded-xl border border-l-4 dark:bg-orange-950 bg-white border-gray-200"
                        >
                          <button
                            type="button"
                            aria-controls="radix-:r22:"
                            aria-expanded="false"
                            data-state="closed"
                            data-slot="collapsible-trigger"
                            class="w-full"
                          >
                            <div class="p-4 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                              <div class="flex items-center justify-between mb-3">
                                <div class="flex items-center gap-3">
                                  <span class="font-medium text-left text-gray-900">
                                    Cybersecurity
                                  </span>
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-orange-600 dark:text-orange-400"
                                  >
                                    HIGH
                                  </span>
                                  <span class="text-sm text-gray-500">
                                    8 items
                                  </span>
                                </div>
                                <div class="flex items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-chevron-down w-5 h-5 text-gray-400"
                                    aria-hidden="true"
                                  >
                                    <path d="m6 9 6 6 6-6"></path>
                                  </svg>
                                </div>
                              </div>
                              <div class="text-sm text-left text-gray-600">
                                Supply chain attacks, VSA vulnerabilities, MSP
                                security model risks
                              </div>
                            </div>
                          </button>
                          <div
                            data-state="closed"
                            id="radix-:r22:"
                            hidden=""
                            data-slot="collapsible-content"
                          ></div>
                        </div>
                      </div>
                      <div data-state="closed" data-slot="collapsible">
                        <div
                          data-slot="card"
                          class="text-card-foreground flex flex-col gap-6 rounded-xl border border-l-4 dark:bg-yellow-950 bg-white border-gray-200"
                        >
                          <button
                            type="button"
                            aria-controls="radix-:r23:"
                            aria-expanded="false"
                            data-state="closed"
                            data-slot="collapsible-trigger"
                            class="w-full"
                          >
                            <div class="p-4 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                              <div class="flex items-center justify-between mb-3">
                                <div class="flex items-center gap-3">
                                  <span class="font-medium text-left text-gray-900">
                                    Market Competition
                                  </span>
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-yellow-600 dark:text-yellow-400"
                                  >
                                    MEDIUM
                                  </span>
                                  <span class="text-sm text-gray-500">
                                    12 items
                                  </span>
                                </div>
                                <div class="flex items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-chevron-down w-5 h-5 text-gray-400"
                                    aria-hidden="true"
                                  >
                                    <path d="m6 9 6 6 6-6"></path>
                                  </svg>
                                </div>
                              </div>
                              <div class="text-sm text-left text-gray-600">
                                Microsoft, ConnectWise, and emerging AI-driven
                                competitors
                              </div>
                            </div>
                          </button>
                          <div
                            data-state="closed"
                            id="radix-:r23:"
                            hidden=""
                            data-slot="collapsible-content"
                          ></div>
                        </div>
                      </div>
                      <div data-state="closed" data-slot="collapsible">
                        <div
                          data-slot="card"
                          class="text-card-foreground flex flex-col gap-6 rounded-xl border border-l-4 dark:bg-yellow-950 bg-white border-gray-200"
                        >
                          <button
                            type="button"
                            aria-controls="radix-:r24:"
                            aria-expanded="false"
                            data-state="closed"
                            data-slot="collapsible-trigger"
                            class="w-full"
                          >
                            <div class="p-4 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                              <div class="flex items-center justify-between mb-3">
                                <div class="flex items-center gap-3">
                                  <span class="font-medium text-left text-gray-900">
                                    Integration Risks
                                  </span>
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-yellow-600 dark:text-yellow-400"
                                  >
                                    MEDIUM
                                  </span>
                                  <span class="text-sm text-gray-500">
                                    6 items
                                  </span>
                                </div>
                                <div class="flex items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-chevron-down w-5 h-5 text-gray-400"
                                    aria-hidden="true"
                                  >
                                    <path d="m6 9 6 6 6-6"></path>
                                  </svg>
                                </div>
                              </div>
                              <div class="text-sm text-left text-gray-600">
                                Datto acquisition integration, platform
                                consolidation challenges
                              </div>
                            </div>
                          </button>
                          <div
                            data-state="closed"
                            id="radix-:r24:"
                            hidden=""
                            data-slot="collapsible-content"
                          ></div>
                        </div>
                      </div>
                      <div data-state="closed" data-slot="collapsible">
                        <div
                          data-slot="card"
                          class="text-card-foreground flex flex-col gap-6 rounded-xl border border-l-4 dark:bg-yellow-950 bg-white border-gray-200"
                        >
                          <button
                            type="button"
                            aria-controls="radix-:r25:"
                            aria-expanded="false"
                            data-state="closed"
                            data-slot="collapsible-trigger"
                            class="w-full"
                          >
                            <div class="p-4 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                              <div class="flex items-center justify-between mb-3">
                                <div class="flex items-center gap-3">
                                  <span class="font-medium text-left text-gray-900">
                                    Regulatory Compliance
                                  </span>
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-yellow-600 dark:text-yellow-400"
                                  >
                                    MEDIUM
                                  </span>
                                  <span class="text-sm text-gray-500">
                                    9 items
                                  </span>
                                </div>
                                <div class="flex items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-chevron-down w-5 h-5 text-gray-400"
                                    aria-hidden="true"
                                  >
                                    <path d="m6 9 6 6 6-6"></path>
                                  </svg>
                                </div>
                              </div>
                              <div class="text-sm text-left text-gray-600">
                                GDPR, SOC 2, data sovereignty across 20+
                                countries
                              </div>
                            </div>
                          </button>
                          <div
                            data-state="closed"
                            id="radix-:r25:"
                            hidden=""
                            data-slot="collapsible-content"
                          ></div>
                        </div>
                      </div>
                      <div data-state="closed" data-slot="collapsible">
                        <div
                          data-slot="card"
                          class="text-card-foreground flex flex-col gap-6 rounded-xl border border-l-4 dark:bg-green-950 bg-white border-gray-200"
                        >
                          <button
                            type="button"
                            aria-controls="radix-:r26:"
                            aria-expanded="false"
                            data-state="closed"
                            data-slot="collapsible-trigger"
                            class="w-full"
                          >
                            <div class="p-4 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                              <div class="flex items-center justify-between mb-3">
                                <div class="flex items-center gap-3">
                                  <span class="font-medium text-left text-gray-900">
                                    Customer Concentration
                                  </span>
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-green-600 dark:text-green-400"
                                  >
                                    LOW
                                  </span>
                                  <span class="text-sm text-gray-500">
                                    4 items
                                  </span>
                                </div>
                                <div class="flex items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-chevron-down w-5 h-5 text-gray-400"
                                    aria-hidden="true"
                                  >
                                    <path d="m6 9 6 6 6-6"></path>
                                  </svg>
                                </div>
                              </div>
                              <div class="text-sm text-left text-gray-600">
                                Well-diversified MSP customer base, minimal
                                concentration risk
                              </div>
                            </div>
                          </button>
                          <div
                            data-state="closed"
                            id="radix-:r26:"
                            hidden=""
                            data-slot="collapsible-content"
                          ></div>
                        </div>
                      </div>
                      <div data-state="closed" data-slot="collapsible">
                        <div
                          data-slot="card"
                          class="text-card-foreground flex flex-col gap-6 rounded-xl border border-l-4 dark:bg-green-950 bg-white border-gray-200"
                        >
                          <button
                            type="button"
                            aria-controls="radix-:r27:"
                            aria-expanded="false"
                            data-state="closed"
                            data-slot="collapsible-trigger"
                            class="w-full"
                          >
                            <div class="p-4 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                              <div class="flex items-center justify-between mb-3">
                                <div class="flex items-center gap-3">
                                  <span class="font-medium text-left text-gray-900">
                                    Financial
                                  </span>
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-green-600 dark:text-green-400"
                                  >
                                    LOW
                                  </span>
                                  <span class="text-sm text-gray-500">
                                    3 items
                                  </span>
                                </div>
                                <div class="flex items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-chevron-down w-5 h-5 text-gray-400"
                                    aria-hidden="true"
                                  >
                                    <path d="m6 9 6 6 6-6"></path>
                                  </svg>
                                </div>
                              </div>
                              <div class="text-sm text-left text-gray-600">
                                Strong recurring revenue model, healthy cash
                                flow
                              </div>
                            </div>
                          </button>
                          <div
                            data-state="closed"
                            id="radix-:r27:"
                            hidden=""
                            data-slot="collapsible-content"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h2 class="text-xl font-medium mb-6 text-gray-900">
                      Recent News & Social Feed
                    </h2>
                    <div class="space-y-4">
                      <div
                        data-slot="card"
                        class="text-card-foreground flex flex-col gap-6 rounded-xl border p-4 bg-white border-gray-200 hover:shadow-md transition-shadow"
                      >
                        <div class="flex items-start gap-3 mb-3">
                          <span
                            data-slot="badge"
                            class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden text-foreground [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs flex-shrink-0 mt-1"
                          >
                            Leadership
                          </span>
                          <span class="text-xs text-gray-500 flex-shrink-0 mt-1">
                            June 3, 2025
                          </span>
                        </div>
                        <div class="flex items-start gap-4">
                          <div class="flex-shrink-0">
                            <img
                              src="https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=400&amp;q=80"
                              alt="TechCrunch"
                              class="w-10 h-10 rounded-lg object-cover"
                            />
                          </div>
                          <div class="flex-1 min-w-0">
                            <div class="text-xs mb-2 text-gray-500">
                              channele2e.com
                            </div>
                            <h3 class="font-medium leading-snug mb-2 text-gray-900">
                              Kaseya Appoints Rania Succar as CEO — Rania
                              Succar, former Intuit Mailchimp and QuickBooks
                              Money leader, will guide Kaseya's next phase of
                              innovation and potential IPO.
                            </h3>
                            <div class="flex items-center justify-between">
                              <div class="flex items-center gap-4 text-sm text-gray-500">
                                <button class="flex items-center gap-1 hover:text-sai-blue transition-colors">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-external-link w-3 h-3"
                                    aria-hidden="true"
                                  >
                                    <path d="M15 3h6v6"></path>
                                    <path d="M10 14 21 3"></path>
                                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                  </svg>
                                  Read more
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-slot="card"
                        class="text-card-foreground flex flex-col gap-6 rounded-xl border p-4 bg-white border-gray-200 hover:shadow-md transition-shadow"
                      >
                        <div class="flex items-start gap-3 mb-3">
                          <span
                            data-slot="badge"
                            class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden text-foreground [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs flex-shrink-0 mt-1"
                          >
                            Product
                          </span>
                          <span class="text-xs text-gray-500 flex-shrink-0 mt-1">
                            April 29, 2025
                          </span>
                        </div>
                        <div class="flex items-start gap-4">
                          <div class="flex-shrink-0">
                            <img
                              src="https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=400&amp;q=80"
                              alt="Security Week"
                              class="w-10 h-10 rounded-lg object-cover"
                            />
                          </div>
                          <div class="flex-1 min-w-0">
                            <div class="text-xs mb-2 text-gray-500">
                              prnewswire.com
                            </div>
                            <h3 class="font-medium leading-snug mb-2 text-gray-900">
                              Kaseya 365 Ops & SIEM Launched at Connect 2025 —
                              AI-powered workflows (Ops) and integrated threat
                              monitoring (SIEM) unveiled, offering automation,
                              threat correlation via RocketCyber/SaaS Alerts,
                              and Datto hardware bonuses. Customers report ~160
                              hours/month reclaimed.
                            </h3>
                            <div class="flex items-center justify-between">
                              <div class="flex items-center gap-4 text-sm text-gray-500">
                                <button class="flex items-center gap-1 hover:text-sai-blue transition-colors">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-external-link w-3 h-3"
                                    aria-hidden="true"
                                  >
                                    <path d="M15 3h6v6"></path>
                                    <path d="M10 14 21 3"></path>
                                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                  </svg>
                                  Read more
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-slot="card"
                        class="text-card-foreground flex flex-col gap-6 rounded-xl border p-4 bg-white border-gray-200 hover:shadow-md transition-shadow"
                      >
                        <div class="flex items-start gap-3 mb-3">
                          <span
                            data-slot="badge"
                            class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden text-foreground [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs flex-shrink-0 mt-1"
                          >
                            Leadership
                          </span>
                          <span class="text-xs text-gray-500 flex-shrink-0 mt-1">
                            20 months ago
                          </span>
                        </div>
                        <div class="space-y-3">
                          <div class="flex items-start gap-3">
                            <div class="flex-shrink-0">
                              <img
                                src="https://pbs.twimg.com/profile_images/1923419604103081984/ygI2qdPr_x96.png"
                                alt="Kaseya"
                                class="w-10 h-10 rounded-full object-cover"
                              />
                            </div>
                            <div class="flex-1 min-w-0">
                              <div class="flex items-center gap-2 mb-1">
                                <span class="font-medium text-gray-900">
                                  Kaseya
                                </span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="lucide lucide-badge-check w-4 h-4 text-sai-blue fill-current"
                                  aria-hidden="true"
                                >
                                  <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"></path>
                                  <path d="m9 12 2 2 4-4"></path>
                                </svg>
                                <span class="text-sm text-gray-500">
                                  @KaseyaCorp
                                </span>
                              </div>
                            </div>
                            <div class="flex-shrink-0">
                              <button
                                data-slot="button"
                                class="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50 rounded-md gap-1.5 has-[&gt;svg]:px-2.5 h-6 w-6 p-0"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="lucide lucide-ellipsis w-3 h-3"
                                  aria-hidden="true"
                                >
                                  <circle cx="12" cy="12" r="1"></circle>
                                  <circle cx="19" cy="12" r="1"></circle>
                                  <circle cx="5" cy="12" r="1"></circle>
                                </svg>
                              </button>
                            </div>
                          </div>
                          <div class="text-sm leading-relaxed text-gray-700">
                            Kaseya 365 Ops joins Kaseya 365 Endpoint and Kaseya
                            365 User to form a complete, integrated solution for
                            everything IT technicians need to secure, manage and
                            operate modern IT environments.
                          </div>
                          <div class="flex items-center justify-between pt-2 border-t border-gray-200 dark:border-gray-700">
                            <div class="flex items-center gap-6">
                              <button class="flex items-center gap-1 text-sm text-gray-500 hover:text-red-500 transition-colors">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="lucide lucide-heart w-4 h-4"
                                  aria-hidden="true"
                                >
                                  <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path>
                                </svg>
                                156
                              </button>
                              <button class="flex items-center gap-1 text-sm text-gray-500 hover:text-sai-blue transition-colors">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="lucide lucide-message-circle w-4 h-4"
                                  aria-hidden="true"
                                >
                                  <path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"></path>
                                </svg>
                                12
                              </button>
                              <button class="flex items-center gap-1 text-sm text-gray-500 hover:text-sai-green transition-colors">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="lucide lucide-repeat2 lucide-repeat-2 w-4 h-4"
                                  aria-hidden="true"
                                >
                                  <path d="m2 9 3-3 3 3"></path>
                                  <path d="M13 18H7a2 2 0 0 1-2-2V6"></path>
                                  <path d="m22 15-3 3-3-3"></path>
                                  <path d="M11 6h6a2 2 0 0 1 2 2v10"></path>
                                </svg>
                                34
                              </button>
                            </div>
                            <button class="flex items-center gap-1 text-sm text-gray-500 hover:text-sai-blue transition-colors">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-share w-4 h-4"
                                aria-hidden="true"
                              >
                                <path d="M12 2v13"></path>
                                <path d="m16 6-4-4-4 4"></path>
                                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
                              </svg>
                              Share
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="flex justify-center pt-4">
                        <button
                          data-slot="button"
                          class="justify-center whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border bg-background text-foreground hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 h-9 px-4 py-2 has-[&gt;svg]:px-3 flex items-center gap-2"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-chevron-down w-4 h-4"
                            aria-hidden="true"
                          >
                            <path d="m6 9 6 6 6-6"></path>
                          </svg>
                          Show More News (4 more items)
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-8 pt-8 border-t border-gray-200 dark:border-gray-700">
                  <div class="mb-4">
                    <h3 class="text-lg font-medium text-gray-900">
                      Quick Actions
                    </h3>
                    <p class="text-sm text-gray-600">
                      Access key features and generate reports for Kaseya
                    </p>
                  </div>
                  <div class="flex flex-wrap gap-4">
                    <button
                      data-slot="button"
                      class="justify-center whitespace-nowrap font-medium disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive h-10 rounded-md has-[&gt;svg]:px-4 flex items-center gap-3 bg-sai-blue hover:bg-sai-blue-hover text-white px-8 py-4 text-base shadow-lg hover:shadow-xl transition-all duration-200"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-chart-column w-5 h-5"
                        aria-hidden="true"
                      >
                        <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                        <path d="M18 17V9"></path>
                        <path d="M13 17V5"></path>
                        <path d="M8 17v-3"></path>
                      </svg>
                      <Link to="/summary">Run Full Due Diligence Analysis</Link>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-arrow-right w-4 h-4"
                        aria-hidden="true"
                      >
                        <path d="M5 12h14"></path>
                        <path d="m12 5 7 7-7 7"></path>
                      </svg>
                    </button>
                    <button
                      data-slot="button"
                      class="justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border bg-background text-foreground hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 h-10 rounded-md has-[&gt;svg]:px-4 flex items-center gap-2 px-6 py-4"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-file-text w-4 h-4"
                        aria-hidden="true"
                      >
                        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                        <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                        <path d="M10 9H8"></path>
                        <path d="M16 13H8"></path>
                        <path d="M16 17H8"></path>
                      </svg>
                      Generate Executive Report
                    </button>
                    <button
                      data-slot="button"
                      class="justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border bg-background text-foreground hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 h-10 rounded-md has-[&gt;svg]:px-4 flex items-center gap-2 px-6 py-4"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-shield w-4 h-4"
                        aria-hidden="true"
                      >
                        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      </svg>
                      Security Deep Dive
                    </button>
                    <button
                      data-slot="button"
                      class="justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border bg-background text-foreground hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 h-10 rounded-md has-[&gt;svg]:px-4 flex items-center gap-2 px-6 py-4"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-settings w-4 h-4"
                        aria-hidden="true"
                      >
                        <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                      Analysis Settings
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
